// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoaderContainer_loaderContainer__LzXw2"};